import { useCallback } from 'react';
import { ISeriesApi, IChartApi } from 'lightweight-charts';
import { ChartTypeEnum } from '../../../../model/chart_type.enum';
import { error, lightBlue, success } from '../../../../theme/colors';

interface CreateSeriesOpts {
  withMarkers?: boolean;
}

export const useCreateSeries = (chartRef: React.MutableRefObject<IChartApi | undefined>) => {
  const createSeries = useCallback(
    (type: ChartTypeEnum, opts: CreateSeriesOpts = {}): ISeriesApi<any> => {
      const c = chartRef.current;
      if (!c) throw new Error('Chart instance is not initialized');

      switch (type) {
        case ChartTypeEnum.HollowCandles:
        case ChartTypeEnum.CandleStick: {
          return c.addCandlestickSeries({
            upColor: success[3],
            downColor: error[3],
            borderDownColor: error[3],
            borderUpColor: success[3],
            wickDownColor: error[3],
            wickUpColor: success[3],
          });
        }
        case ChartTypeEnum.Bars:
          return c.addBarSeries({ upColor: success[3], downColor: error[3] });
        case ChartTypeEnum.Line:
        case ChartTypeEnum.Area:
          return type === ChartTypeEnum.Line
            ? c.addLineSeries({ color: lightBlue, lineWidth: 1 })
            : c.addAreaSeries({
                lineColor: lightBlue,
                topColor: lightBlue,
                bottomColor: 'transparent',
                lineWidth: 1,
              });
        case ChartTypeEnum.LineWMarkers: {
          const line = c.addLineSeries({ color: lightBlue, lineWidth: 1 });
          if (opts.withMarkers) {
            line.setMarkers([]);
          }
          return line;
        }
        case ChartTypeEnum.Columns:
          return c.addHistogramSeries({ color: lightBlue });
        default:
          throw new Error(`Unsupported chart type: ${type}`);
      }
    },
    [chartRef],
  );
  return createSeries;
};
